import React from 'react';
import PropTypes from 'prop-types';
import {
  Alert
} from 'day8-react/build/new-components';
import { FaUserCircle } from "@react-icons/all-files/fa/FaUserCircle";
import { RxCross1 } from "@react-icons/all-files/rx/RxCross1";
import { Input, Select, Avatar, Button } from 'day8-ui';
import { countries } from 'countries-list';
import { getProfileImage } from '../../../helpers/crew';
import { useEditProfilePictureModal } from '../../../context/EditProfilePictureModalContext';
import { useSelector } from 'react-redux';
import { validatePassport, validatePhone } from '../../../utils/profileValidation';

const days = [...Array(31)].map((day, i) => ({
  text: i + 1,
  value: i + 1
}));

const months = [
  {
    text: 'Jan',
    value: 1
  },
  {
    text: 'Feb',
    value: 2
  },
  {
    text: 'Mar',
    value: 3
  },
  {
    text: 'Apr',
    value: 4
  },
  {
    text: 'May',
    value: 5
  },
  {
    text: 'Jun',
    value: 6
  },
  {
    text: 'Jul',
    value: 7
  },
  {
    text: 'Aug',
    value: 8
  },
  {
    text: 'Sep',
    value: 9
  },
  {
    text: 'Oct',
    value: 10
  },
  {
    text: 'Nov',
    value: 11
  },
  {
    text: 'Dec',
    value: 12
  }
];

function range(start, count) {
  return Array.apply(0, Array(count))
    .map((element, index) => ({
      text: start - index,
      value: start - index
    }));
}

const years = range(2019, 80);
const countryList = Object.entries(countries)
  .map(([countryCode, countryData]) => ({ value: countryCode, text: countryData.name }))
  .sort((a, b) => (a.text > b.text) ? 1 : -1);

const EditProfileSection = ({
  userFormData,
  onChange,
  onPhoneChange,
  notifications = {},
  hideNotification,
  fieldErrors = {},
  onFieldBlur
}) => {
  const loggedUser = useSelector(state => state.user.loggedUser);
  const { open } = useEditProfilePictureModal();
  const imageObj = loggedUser ? getProfileImage(loggedUser.fbUid, loggedUser.profilePicture, loggedUser.name) : null;
  return (
    <div className="grid grid-gap-md margin-top-md margin-bottom-xl">
      <div className="col-12">
        <h3 className="yw-app-h3 dui-mb-2">Personal details</h3>
      </div>
      <div className="">
        <div>
          <p className="dui-mb-2 dui-font-subheading dui-text-[12px] dui-font-bold dui-uppercase" style={{ letterSpacing: '0.12em', color: 'var(--yw-fg-muted, #5e7289)' }}>
            Profile picture
          </p>
          {imageObj && (
            <div className='dui-relative'>
              <button
                type="button"
                onClick={() => open()}
                className='dui-transition hover:dui-opacity-75'
                aria-label="Remove file"
              >
                <div className='dui-relative'>
                  <Avatar avatarSize='LARGE'>
                    {imageObj && imageObj.url && <img src={imageObj.url} alt={imageObj.alt} className="dui-w-full dui-h-full dui-object-cover" />}
                  </Avatar>
                  <div className='dui-absolute dui-top-0 dui-right-1 dui-bg-primary-950 dui-text-white dui-rounded-full dui-p-1 dui-flex dui-items-center dui-justify-center dui-cursor-pointer dui-transition-colors'>
                    <RxCross1 size={16} />
                  </div>
                </div>
              </button>
            </div>
          )}
        </div>
        {!imageObj && (
          <Button buttonType='PRIMARY' rightIcon={<FaUserCircle />} onClick={() => open()}>Add profile picture</Button>
        )}
      </div>
      <div className="col-12 col-6@sm" data-account-edit-field="firstName">
        <Input
          label="FIRST NAME*"
          type="text"
          name="firstName"
          placeholder="Your first name"
          value={userFormData.firstName}
          onChange={onChange}
          className='dui-max-w-full'
          errorMessage={fieldErrors.firstName || (notifications.error && notifications.error.firstName?.notificationMessage)}
        />
      </div>
      <div className="col-12 col-6@sm" data-account-edit-field="lastName">
        <Input
          label="LAST NAME*"
          type="text"
          name="lastName"
          placeholder="Your first name"
          value={userFormData.lastName}
          onChange={onChange}
          className='dui-max-w-full'
          errorMessage={fieldErrors.lastName || (notifications.error && notifications.error.lastName?.notificationMessage)}
        />
      </div>
      <div className="col-12 col-6@sm" data-account-edit-field="sex">
        <Select
          label="SEX*"
          name="sex"
          className="dui-w-full"
          containerClassName="dui-w-full"
          defaultLabel={"Select option..."}
          value={userFormData.sex || ""}
          onChange={onChange}
          options={
            [
              { text: 'Male', value: 'M' },
              { text: 'Female', value: 'F' }
            ]
          }
          errorMessage={fieldErrors.sex || (notifications.error && notifications.error.sex?.notificationMessage)}
        />
      </div>
      <div className="col-12 col-6@sm" data-account-edit-field="birthDate">
        <label className='dui-mb-2 dui-block'>BIRTH DATE*</label>
        <div className="grid grid-gap-sm dui-max-w-full">

          <div className="col-4">
            <Select
              labelHidden
              defaultLabel={"Day..."}
              options={days}
              name="birthDate"
              dataRepeatType="day"
              value={userFormData.birthDate?.day || ""}
              onChange={onChange}
              className='dui-max-w-full'
              errorMessage={!!(fieldErrors.birthDate || notifications?.error?.birthDate)}
            />
          </div>
          <div className="col-4">
            <Select
              labelHidden
              defaultLabel={"Month..."}
              options={months}
              name="birthDate"
              dataRepeatType="month"
              value={userFormData.birthDate?.month || ""}
              onChange={onChange}
              className='dui-max-w-full'
              errorMessage={!!(fieldErrors.birthDate || notifications?.error?.birthDate)}
            />
          </div>
          <div className="col-4">
            <Select
              labelHidden
              defaultLabel={"Year..."}
              options={years}
              name="birthDate"
              dataRepeatType="year"
              value={userFormData.birthDate?.year || ""}
              onChange={onChange}
              className='dui-max-w-full'
              errorMessage={!!(fieldErrors.birthDate || notifications?.error?.birthDate)}
            />
          </div>
        </div>
        {(fieldErrors.birthDate || notifications?.error?.birthDate) && (
          <Alert
            className="dui-mt-4"
            show
            text={
              fieldErrors.birthDate
              || notifications?.error?.birthDate?.notificationMessage
            }
            type="error"
            onClose={hideNotification}
          />
        )}
      </div>
      <div className="col-12">
        <div
          className="dui-mt-4 dui-border dui-border-solid dui-p-5"
          style={{ borderColor: 'var(--yw-teal, #00dcbb)', borderWidth: 1.5 }}
        >
          <div className="dui-font-subheading dui-text-[13px] dui-font-bold dui-uppercase" style={{ letterSpacing: '0.12em', color: 'var(--yw-navy, #122f51)' }}>
            Mandatory for crew list manifest
          </div>
          <p className="dui-mt-1.5 dui-leading-relaxed" style={{ fontSize: 13.5, fontWeight: 200, color: 'var(--yw-fg-muted, #5e7289)' }}>
            Required by the charter company before check-in.
          </p>
          <div className="dui-mt-5 dui-grid dui-grid-cols-1 dui-gap-5 md:dui-grid-cols-2">
            <div data-account-edit-field="nationality">
              <Select
                label="NATIONALITY*"
                defaultLabel={"Select option..."}
                options={countryList}
                value={userFormData.nationality || ""}
                name="nationality"
                className="dui-w-full"
                onChange={onChange}
                errorMessage={fieldErrors.nationality || (notifications.error && notifications.error.nationality?.notificationMessage)}
              />
            </div>
            <div data-account-edit-field="passport">
              <Input
                label="PASSPORT NUMBER*"
                type="text"
                name="passport"
                placeholder="Number on your passport"
                className="dui-w-full"
                value={userFormData.passport}
                onChange={onChange}
                onBlur={() => onFieldBlur && onFieldBlur('passport', validatePassport(userFormData.passport, userFormData.nationality))}
                errorMessage={
                  fieldErrors.passport
                  || (notifications.error && notifications.error.passport?.notificationMessage)
                }
              />
              <small>If you do not have your passport details available please contact hello@theyachtweek.com</small>
            </div>
            <div data-account-edit-field="nationalId">
              <Input
                label="NATIONAL ID"
                type="text"
                name="nationalId"
                placeholder="National ID / identity card number (optional)"
                className="dui-w-full"
                value={userFormData.nationalId || ""}
                onChange={onChange}
                errorMessage={notifications.error && notifications.error.nationalId?.notificationMessage}
              />
            </div>
            <div data-account-edit-field="birthCountry">
              <Select
                label="COUNTRY OF BIRTH*"
                defaultLabel={"Select option..."}
                options={countryList}
                value={userFormData.birthCountry || ""}
                name="birthCountry"
                className="dui-w-full"
                onChange={onChange}
                errorMessage={fieldErrors.birthCountry || (notifications.error && notifications.error.birthCountry?.notificationMessage)}
              />
            </div>
            <div data-account-edit-field="placeOfBirth">
              <Input
                label="PLACE OF BIRTH*"
                type="text"
                name="placeOfBirth"
                placeholder="City or town of birth"
                className="dui-w-full"
                value={userFormData.placeOfBirth || ""}
                onChange={onChange}
                errorMessage={fieldErrors.placeOfBirth || (notifications.error && notifications.error.placeOfBirth?.notificationMessage)}
              />
            </div>
          </div>

          <div className="dui-mt-8">
            <div>
              <div className="dui-font-subheading dui-text-[13px] dui-font-bold dui-uppercase" style={{ letterSpacing: '0.12em', color: 'var(--yw-navy, #122f51)' }}>
                Emergency contact *
              </div>
              <p className="dui-mt-1.5 dui-leading-relaxed" style={{ fontSize: 13.5, fontWeight: 200, color: 'var(--yw-fg-muted, #5e7289)' }}>
                Someone we can contact in an emergency — never used for marketing.
              </p>
            </div>
            <div className="dui-mt-5 dui-grid dui-grid-cols-1 dui-gap-5 md:dui-grid-cols-2">
              <div data-account-edit-field="nextOfKinFirstName">
                <Input
                  label="FIRST NAME*"
                  type="text"
                  name="nextOfKinFirstName"
                  placeholder="First name..."
                  className="dui-w-full"
                  value={userFormData.nextOfKinFirstName}
                  onChange={onChange}
                  errorMessage={
                    fieldErrors.nextOfKinFirstName
                    || (notifications.error && notifications.error.nextOfKinFirstName?.notificationMessage)
                  }
                />
              </div>
              <div data-account-edit-field="nextOfKinLastName">
                <Input
                  label="LAST NAME*"
                  type="text"
                  name="nextOfKinLastName"
                  placeholder="Last name..."
                  className="dui-w-full"
                  value={userFormData.nextOfKinLastName}
                  onChange={onChange}
                  errorMessage={
                    fieldErrors.nextOfKinLastName
                    || (notifications.error && notifications.error.nextOfKinLastName?.notificationMessage)
                  }
                />
              </div>
              <div data-account-edit-field="nextOfKinRelationship">
                <Input
                  label="RELATIONSHIP*"
                  type="text"
                  name="nextOfKinRelationship"
                  placeholder="Your link with that person..."
                  className="dui-w-full"
                  value={userFormData.nextOfKinRelationship}
                  onChange={onChange}
                  errorMessage={
                    fieldErrors.nextOfKinRelationship
                    || (notifications.error && notifications.error.nextOfKinRelationship?.notificationMessage)
                  }
                />
              </div>
              <div data-account-edit-field="nextOfKinPhone">
                <Input
                  label="PHONE*"
                  type="tel"
                  name="nextOfKinPhone"
                  placeholder="eg: +44 7123 456789"
                  className="dui-w-full"
                  value={userFormData.nextOfKinPhone || ''}
                  onChange={onPhoneChange}
                  onBlur={() => onFieldBlur && onFieldBlur(
                    'nextOfKinPhone',
                    !userFormData.nextOfKinPhone ? 'Emergency contact phone is required' : validatePhone(userFormData.nextOfKinPhone, userFormData.country || userFormData.nationality)
                  )}
                  errorMessage={
                    fieldErrors.nextOfKinPhone
                    || (notifications.error && notifications.error.nextOfKinPhone?.notificationMessage)
                  }
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditProfileSection;

EditProfileSection.propTypes = {
  userFormData: PropTypes.object.isRequired,
  onChange: PropTypes.func,
  onPhoneChange: PropTypes.func,
  hideNotification: PropTypes.func,
  notifications: PropTypes.object,
  fieldErrors: PropTypes.object,
  onFieldBlur: PropTypes.func
};
